import React from 'react';

import { fg } from '@confluence/feature-gating';
import { LoadableLazy } from '@confluence/loadable';

export { useModernizeChangeboardingActive } from './hooks/useModernizeChangeboardingActive';

const ModernizeChangeboardingLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ModernizeChangeboarding" */ './ModernizeChangeboarding'
			)
		).ModernizeChangeboarding,
});

export const ModernizeChangeboarding = () => {
	return fg('cc_modernize_ga_changeboarding') ? <ModernizeChangeboardingLoadable /> : null;
};
